export default "__VITE_ASSET__CE7g$6LY__"